
export class PDFViewerPageType {
    width = 0;
    height = 0;
    type = ''
}

/** pdf viewer 文档页面信息 */
export class PDFViewerDocumentPage {
    height = 0;
    width = 0;
    pixelHeight = 0;
    pixelWidth = 0;
    type = new PDFViewerPageType();
}


/** 图片管理对象 */
export class ImageManager {
    _page = new PDFViewerDocumentPage();
    // /** 宽度 */
    width = 0;
    // /** 高度 */
    height = 0;

    /**
     * 图片管理对象构造器
     * @param page 页面信息
     * @param pageNumber 页码
     * @param url 图片加载地址
     * @param crossOrigin 跨域配置
     */
    constructor(page: PDFViewerDocumentPage, public pageNumber: number, public url: string, public crossOrigin: string = 'Anonymous') {
        this.width = page.pixelWidth;
        this.height = page.pixelHeight;
        this._page = page;
    }

    /** 页码数据 */
    get _pageInfo() {
        return {
            view: [1, 1, this.width, this.height],
            pageIndex: this.pageNumber - 1
        }
    }

    /** 视窗信息 */
    getViewport({
        scale = 1,
        rotation = 0
    }) {
        const angle = (rotation % 360 / 180) * Math.PI;
        return {
            transform: [Math.cos(angle), Math.sin(angle), -Math.sin(angle), Math.cos(angle), 0, 0],
            width: this.width * scale,
            height: this.height * scale,
            viewBox: [0, 0, this.width, this.height]
        }
    }

    /** 图片规格 */
    get spec() {
        const { type: { width, height, type: pageType } } = this._page;
        const direction = width < height ? '纵向' : '横向';
        return `${pageType} ${width}mm * ${height}mm ${direction}`;
    }
}